import {useEffect} from 'react';

/**
 * This hook will find and focus on the first focusable DOM node in the given
 * container element. It accepts a ref that contains the DOM node to
 * search within, as well as an optional list of dependencies, which determines
 * when the hook is re-run (ie, when the dependencies change, the container will
 * be re-searched, and the first found element focused on again).
 */
export const useFocusFirst = (
  containerRef: React.MutableRefObject<HTMLElement | null>,
  dependencies?: unknown[],
  focus = true,
) => {
  useEffect(
    () => {
      if (containerRef.current) {
        const focusable: HTMLElement | null = containerRef.current.querySelector(
          'button, [href], input, select, textarea, [tabindex]',
        );

        if (focus) {
          focusable?.focus();
        }
      }
    },
    // Dependencies are based on function parameters, and cannot be statically
    // typed, so we're disabling the eslint rule here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...(dependencies || [])],
  );
};
